import {BGColor} from './colors';
import {PageUser} from './pages';

import {OrderDirection} from '.';

export type GridCellData =
    | string
    | boolean
    | string[]
    | GridTicketData
    | GridUserData
    | GridEnumTicketField
    | GridUserData[];

export type GridUserData = PageUser | UnresolvedPageUser;

interface UnresolvedPageUser {
    username: string;
}

export interface GridTicketData {
    key: string;
    resolved: boolean;
}

// status, priority and type
export interface GridEnumTicketField {
    key: string;
    display: string;
}

export interface GridRow {
    id: string;
    color: BGColor | null;
    pinned: boolean;
    row: GridCellData[];
}

export interface GridSort {
    slug: string;
    direction: OrderDirection;
    title?: string;
}

export type GridDefaultSort = Record<string, OrderDirection>;

export interface GridStructure {
    default_sort?: GridSort[];
    columns: GridField[];
}

export type GridFieldWidthUnits = '%' | 'px';

export interface GridField {
    slug: string;
    title: string;
    type: GridFieldType;
    required: boolean;
    description?: string;
    width?: number | null;
    width_units?: GridFieldWidthUnits;
    // TODO ask backend again about the format of the pinned
    pinned?: 'left' | 'right' | null;
    color: BGColor | null;
    multiple?: boolean;
    format?: GridStringFieldFormat;
    ticket_field?: GridTicketFieldType;
    select_options?: string[];
    mark_rows?: boolean;
}

export enum GridFieldType {
    String = 'string',
    Number = 'number',
    Date = 'date',
    Select = 'select',
    Staff = 'staff',
    Checkbox = 'checkbox',
    Ticket = 'ticket',
    TicketField = 'ticket_field',
}

export enum GridStringFieldFormat {
    Plain = 'plain',
    Yfm = 'yfm',
    WikiMarkup = 'wom',
}

export enum GridTicketFieldType {
    Assignee = 'assignee',
    Reporter = 'reporter',
    Status = 'status',
    Priority = 'priority',
    Type = 'type',
    Subject = 'subject',
    UpdatedAt = 'updated_at',
    CreatedAt = 'created_at',
    OriginalEstimation = 'original_estimation',
    FixVersions = 'fixversions',
    Components = 'components',
    StoryPoints = 'storypoints',
}

export interface GridChange {
    editors: PageUser[];
    last_revision: string;
}

export interface GridChangePoint {
    gridId: string;
    revision: string;
}
